'use es6';

import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
const SUBSCRIPTION_DEFINITION_URL = '/subscriptions/v1/definitions/ensure-at-least-active/';
const TRANSLATION_BASE_URL = '/subscriptions/v1/translations';
const DEFAULT_SUBSCRIPTION = 'MARKETING_INFORMATION';
export function fetchSubscriptionDefinitionsByBusinessUnitId({
  businessUnitId = 0,
  hasBusinessUnitsAccess = false,
  isUngatedForCampaignBusinessUnit = false
}) {
  const portalId = PortalIdParser.get();
  return http.put(`${SUBSCRIPTION_DEFINITION_URL}${DEFAULT_SUBSCRIPTION}`, {
    query: Object.assign({
      portalId,
      includeInactive: false
    }, hasBusinessUnitsAccess && isUngatedForCampaignBusinessUnit && {
      businessUnitId
    })
  });
}
export const fetchSubscriptionsTranslations = () => http.get(TRANSLATION_BASE_URL);